var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeftIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7281 8.33329H5.86978L11.4603 2.85447C11.7793 2.54089 11.9586 2.11558 11.9586 1.67211C11.9586 1.22864 11.7793 0.80333 11.4603 0.489749C11.1413 0.176168 10.7087 0 10.2575 0C9.80638 0 9.37371 0.176168 9.05471 0.489749L0.584162 8.81622C0.42993 8.9746 0.309029 9.16135 0.228399 9.36577C0.058958 9.7712 0.058958 10.226 0.228399 10.6314C0.309029 10.8358 0.42993 11.0226 0.584162 11.1809L9.05471 19.5074C9.2122 19.6635 9.39957 19.7874 9.60601 19.8719C9.81245 19.9565 10.0339 20 10.2575 20C10.4812 20 10.7026 19.9565 10.909 19.8719C11.1155 19.7874 11.3029 19.6635 11.4603 19.5074C11.6191 19.3526 11.7452 19.1684 11.8312 18.9655C11.9172 18.7626 11.9615 18.5449 11.9615 18.3251C11.9615 18.1052 11.9172 17.8875 11.8312 17.6846C11.7452 17.4817 11.6191 17.2975 11.4603 17.1427L5.86978 11.6639H18.7281C19.1774 11.6639 19.6083 11.4884 19.926 11.1761C20.2437 10.8638 20.4222 10.4402 20.4222 9.99858C20.4222 9.55692 20.2437 9.13334 19.926 8.82104C19.6083 8.50874 19.1774 8.33329 18.7281 8.33329Z",
    fill: "#131313"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftIcon);
export default __webpack_public_path__ + "static/media/arrow-left-icon.44d3c493d65efcb5c237ee7253a18ae1.svg";
export { ForwardRef as ReactComponent };